var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoralisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}.cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -102.79,
    cy: 289.75,
    r: 1,
    gradientTransform: "matrix(-26.32, -37.29, -56.62, 39.97, 13747.87, -15356.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09ffd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009eff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -102.79,
    cy: 289.75,
    r: 1,
    gradientTransform: "matrix(-26.32, -37.29, -56.62, 39.97, 13747.87, -15356.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56beff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.5,16.8a14.1,14.1,0,0,1,9.57,4.62A14.18,14.18,0,0,1,49.88,17a15.34,15.34,0,0,1,12.57,8.81,19,19,0,0,1,1.81,9.81h0c-.67,7.18-4.93,14.95-9.61,20.17h0c-.46.5-.93,1-1.42,1.48a6.08,6.08,0,0,1-9.33-.49A6.34,6.34,0,0,1,45.13,48c.55-.44,1.16-1,1.69-1.43a20.76,20.76,0,0,0,5.27-6.73,13.28,13.28,0,0,0,1.2-6.35,6,6,0,0,0-3-5.06,6.45,6.45,0,0,0-2.49-.65h0a4.91,4.91,0,0,0-4,1.62,7.76,7.76,0,0,0-1.69,2.71h0a8.7,8.7,0,0,0-.28,1v.12h0l-.09.39h0a4,4,0,0,1-7.67.42l-.13-.3h0c-.07-.17-.13-.34-.2-.52a9.93,9.93,0,0,0-1.88-3.52h0A5.19,5.19,0,0,0,26,28.36a5.81,5.81,0,0,0-3,3,8.81,8.81,0,0,0-.8,4.49,21,21,0,0,0,2.2,7.67,23,23,0,0,0,1.39,2.42,19.82,19.82,0,0,0,1.81,2.35h0a3.21,3.21,0,0,1-3.78,5h0a23.18,23.18,0,0,1-9.49-9.94h0a21,21,0,0,1-2.27-13.91A15.61,15.61,0,0,1,28.5,16.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.5,16.8a14.1,14.1,0,0,1,9.57,4.62A14.18,14.18,0,0,1,49.88,17a15.34,15.34,0,0,1,12.57,8.81,19,19,0,0,1,1.81,9.81h0c-.67,7.18-4.93,14.95-9.61,20.17h0c-.46.5-.93,1-1.42,1.48a6.08,6.08,0,0,1-9.33-.49A6.34,6.34,0,0,1,45.13,48c.55-.44,1.16-1,1.69-1.43a20.76,20.76,0,0,0,5.27-6.73,13.28,13.28,0,0,0,1.2-6.35,6,6,0,0,0-3-5.06,6.45,6.45,0,0,0-2.49-.65h0a4.91,4.91,0,0,0-4,1.62,7.76,7.76,0,0,0-1.69,2.71h0a8.7,8.7,0,0,0-.28,1v.12h0l-.09.39h0a4,4,0,0,1-7.67.42l-.13-.3h0c-.07-.17-.13-.34-.2-.52a9.93,9.93,0,0,0-1.88-3.52h0A5.19,5.19,0,0,0,26,28.36a5.81,5.81,0,0,0-3,3,8.81,8.81,0,0,0-.8,4.49,21,21,0,0,0,2.2,7.67,23,23,0,0,0,1.39,2.42,19.82,19.82,0,0,0,1.81,2.35h0a3.21,3.21,0,0,1-3.78,5h0a23.18,23.18,0,0,1-9.49-9.94h0a21,21,0,0,1-2.27-13.91A15.61,15.61,0,0,1,28.5,16.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoralisLogo);
export default __webpack_public_path__ + "static/media/moralis-logo.aa658eaa416895465a8fcf129380ab15.svg";
export { ForwardRef as ReactComponent };